export default "__VITE_ASSET__CrN9S$45__"